export default __webpack_public_path__ + "static/media/component-82-2@3x.080ac1bb.png";